
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(18(6|93)|5108)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
